import { inject as v, computed as l, getCurrentInstance as K, toRaw as S, watch as m } from "vue";
import { selectKey as w, selectGroupKey as D } from "./index676.js";
import { COMPONENT_NAME as R } from "./index793.js";
import { escapeStringRegexp as A } from "./index755.js";
import { throwError as C } from "./index588.js";
import { isObject as u } from "./index575.js";
import b from "./index764.js";
import g from "./index703.js";
import I from "./index712.js";
function k(r, s) {
  const t = v(w);
  t || C(R, "usage: <el-select><el-option /></el-select/>");
  const p = v(D, { disabled: !1 }), d = l(() => h(b(t.props.modelValue), r.value)), y = l(() => {
    var e;
    if (t.props.multiple) {
      const o = b((e = t.props.modelValue) != null ? e : []);
      return !d.value && o.length >= t.props.multipleLimit && t.props.multipleLimit > 0;
    } else
      return !1;
  }), a = l(() => {
    var e;
    return (e = r.label) != null ? e : u(r.value) ? "" : r.value;
  }), x = l(() => r.value || r.label || ""), f = l(() => r.disabled || s.groupDisabled || y.value), c = K(), h = (e = [], o) => {
    if (u(r.value)) {
      const i = t.props.valueKey;
      return e && e.some((n) => S(g(n, i)) === g(o, i));
    } else
      return e && e.includes(o);
  }, O = () => {
    f.value || (t.states.hoveringIndex = t.optionsArray.indexOf(c.proxy));
  }, E = (e) => {
    const o = new RegExp(A(e), "i");
    s.visible = o.test(String(a.value)) || r.created;
  };
  return m(
    () => a.value,
    () => {
      !r.created && !t.props.remote && t.setSelected();
    }
  ), m(
    () => r.value,
    (e, o) => {
      const { remote: i, valueKey: n } = t.props;
      if ((i ? e !== o : !I(e, o)) && (t.onOptionDestroy(o, c.proxy), t.onOptionCreate(c.proxy)), !r.created && !i) {
        if (n && u(e) && u(o) && e[n] === o[n])
          return;
        t.setSelected();
      }
    }
  ), m(
    () => p.disabled,
    () => {
      s.groupDisabled = p.disabled;
    },
    { immediate: !0 }
  ), {
    select: t,
    currentLabel: a,
    currentValue: x,
    itemSelected: d,
    isDisabled: f,
    hoverItem: O,
    updateOption: E
  };
}
export {
  k as useOption
};
